'use client';

import { c as _c } from "react/compiler-runtime";
import './panel-shifts.scss';
import { useTranslation } from 'react-i18next';
import { ShiftRoleGroup } from '../../../molecules/shift-role-group/shift-role-group.tsx';
import { groupSlotsByRole } from '../../../utils/volunteer-utils.ts';
import { VolunteerErrors } from '../errors/volunteer-errors.tsx';
import type { useVolunteerRegistrationSheet } from '../volunteer-registration-sheet.logic.ts';
type Logic = ReturnType<typeof useVolunteerRegistrationSheet>;
export const PanelShifts: React.FC<{
  logic: Logic;
}> = t0 => {
  const $ = _c(36);
  const {
    logic
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["volunteers"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[1] !== logic || $[2] !== t) {
    const groupedByRole = groupSlotsByRole(logic.slots, t("volunteers:registration.shift"));
    t6 = "flex flex-col max-w-md mx-auto";
    let t10;
    if ($[11] !== t) {
      t10 = t("volunteers:registration.selectShiftsTitle");
      $[11] = t;
      $[12] = t10;
    } else {
      t10 = $[12];
    }
    if ($[13] !== t10) {
      t7 = <div className="flex items-center justify-between"><h3 className="heading-xs md:heading-sm mb-snug-lg">{t10}</h3></div>;
      $[13] = t10;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    let t11;
    if ($[15] !== t) {
      t11 = t("volunteers:registration.selectShiftsDescription", {
        name: t("volunteers:registration.yourGroup")
      });
      $[15] = t;
      $[16] = t11;
    } else {
      t11 = $[16];
    }
    if ($[17] !== t11) {
      t8 = <p className="body-sm body-neutral-mild pb-comfy-sm">{t11}</p>;
      $[17] = t11;
      $[18] = t8;
    } else {
      t8 = $[18];
    }
    if ($[19] !== logic.formErrors) {
      t9 = <VolunteerErrors errors={logic.formErrors} />;
      $[19] = logic.formErrors;
      $[20] = t9;
    } else {
      t9 = $[20];
    }
    t2 = "PanelShifts__roles w-full flex flex-col gap-comfy-lg mx-auto mt-comfy-sm";
    t3 = "group";
    if ($[21] !== t) {
      t4 = t("volunteers:registration.availableShifts");
      $[21] = t;
      $[22] = t4;
    } else {
      t4 = $[22];
    }
    let t12;
    if ($[23] !== logic) {
      t12 = t13 => {
        const [roleLabel, roleSlots] = t13;
        return <ShiftRoleGroup key={roleLabel} roleLabel={roleLabel} roleSlots={roleSlots} logic={logic} />;
      };
      $[23] = logic;
      $[24] = t12;
    } else {
      t12 = $[24];
    }
    t5 = groupedByRole.map(t12);
    $[1] = logic;
    $[2] = t;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
    t8 = $[9];
    t9 = $[10];
  }
  let t10;
  if ($[25] !== t2 || $[26] !== t3 || $[27] !== t4 || $[28] !== t5) {
    t10 = <div className={t2} role={t3} aria-label={t4}>{t5}</div>;
    $[25] = t2;
    $[26] = t3;
    $[27] = t4;
    $[28] = t5;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== t10 || $[31] !== t6 || $[32] !== t7 || $[33] !== t8 || $[34] !== t9) {
    t11 = <div className={t6}>{t7}{t8}{t9}{t10}</div>;
    $[30] = t10;
    $[31] = t6;
    $[32] = t7;
    $[33] = t8;
    $[34] = t9;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  return t11;
};